/**
 * Доступ к командной строке из любого места интерфейса.
 *
 * Сама панель живёт в оболочке приложения — контекст нужен, чтобы кнопка
 * поиска в боковой панели и другие места могли её открыть, не прокидывая
 * колбэки через всё дерево.
 */

import { createContext, use, useMemo, useState, type ReactNode } from 'react';

interface CommandPaletteValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  setOpen: (open: boolean) => void;
}

const CommandPaletteContext = createContext<CommandPaletteValue | null>(null);

export function CommandPaletteProvider({ children }: { children: ReactNode }) {
  const [isOpen, setOpen] = useState(false);

  const value = useMemo<CommandPaletteValue>(
    () => ({
      isOpen,
      open: () => setOpen(true),
      close: () => setOpen(false),
      setOpen,
    }),
    [isOpen],
  );

  return <CommandPaletteContext value={value}>{children}</CommandPaletteContext>;
}

export function useCommandPalette(): CommandPaletteValue {
  const context = use(CommandPaletteContext);
  if (!context) {
    // Панель есть только внутри оболочки приложения; на экране входа её нет.
    return { isOpen: false, open: () => {}, close: () => {}, setOpen: () => {} };
  }
  return context;
}
